import request from "@/utils/request";
// 获取列表
export function getAppConfig(params) {
    return request({
        url: '/api/config/config',
        method: 'get',
        params
    })
}
// 获取友情链接  
export function getLink() {
    return request({
        url: '/api/link/linkList',
        method: 'get'
    })
}